import React, { useEffect, useState } from 'react'

import { Wrapper } from './styles'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from 'chart.js'
import { navigationStatsEndpoints, NavigationStatsObject } from 'src/api'
import VerticalBarVisitsByUser from './VerticalBarVisitsByUser'
import UserSummary from './UserSummary'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, PointElement, LineElement)

export default function StatsScreen() {
  const [navigationStats, setNavigationStats] = useState<NavigationStatsObject>()

  useEffect(() => {
    getNavigationStats()
  }, [])

  const getNavigationStats = async () => {
    const navStats = await navigationStatsEndpoints.getAll()
    setNavigationStats(navStats)
  }

  if (!navigationStats) {
    return null
  }

  return (
    <Wrapper>
      <div className="chart-wrapper">
        <VerticalBarVisitsByUser data={navigationStats?.topMenuVisitsByUserLast7Days} />
      </div>
      <div className="chart-wrapper">
        <UserSummary data={navigationStats?.userSummary} />
      </div>
    </Wrapper>
  )
}
